import { transactionService } from '@/common/api.service'

const initialStates = {
    status: 'loading',
    statistics: {
        total_profit: 0,
        transactions_sum: 0,
        succeeded_trans_count: 0,
        failed_trans_count: 0,
    },
    excelRequests: {}
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    success(state, statistics) {
        state.status    = 'success'
        state.statistics = statistics
    },
    fail(state) {
        state.status    = 'fail'
        state.statistics = []
    },
    setExcelRequests(state , response) {
        state.excelRequests = response.data
    }

}

const getters = {
    status: state => state.status,
    statistics: state => state.statistics,
    excelRequests: state => state.excelRequests
}

const actions = {
    fetchStatistics({commit}, query) {
        commit('loading')
        return transactionService.fetchStatistics(query)
            .then(response => {
                commit('success', response.data.data)
            })
    },
    fetchExcelRequests({commit} , query){
        commit('loading')
        return transactionService.fetchExcelRequests(query)
            .then(response => {
                commit('setExcelRequests' , response.data)
            })
    }
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}